module.exports = __webpack_public_path__ + "img/bg.50fb131b.png";